module.exports = __webpack_public_path__ + "static/onepoint-ebca7ae5cd6e0f64186e27da8f2dd457.png";